/* ─────────────────────────────────────────────────────────────
   Medicore mobile tab bar

   The buttons themselves need no code: Menu carries
   data-mc-nav-toggle and Cart carries data-cart-drawer-open, and
   header-medicore.js / cart-drawer.js already bind those on
   `document`, so both open the drawers the header opens.

   All this file does is keep the cart badge honest in the cases the
   drawer script cannot cover:

     - main.js's updateCartCount() writes to
       document.querySelector('.cart-count') — the first match only,
       which is the header's. The badge here is the second and would
       be left stale after a back/forward restore.
     - cart-drawer.js rewrites the badge text but knows nothing about
       hiding it at zero.

   No dependencies.
   ───────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  function badges() {
    return document.querySelectorAll('[data-mc-tabbar-count]');
  }

  /* Text is written by whoever changed the cart; this only decides
     whether a badge with that text should be visible at all. */
  function syncEmptyState() {
    badges().forEach(function (node) {
      var count = parseInt((node.textContent || '').trim(), 10);
      node.classList.toggle('is-empty', !count || isNaN(count));
    });
  }

  function setCount(count) {
    badges().forEach(function (node) {
      node.textContent = String(count);
    });
    syncEmptyState();
  }

  function refresh() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (cart) setCount(cart.item_count);
      })
      .catch(function () {
        /* A stale badge is a smaller problem than a console error on
           every navigation; the next cart action corrects it. */
      });
  }

  /* Watching the node rather than hooking every script that might
     write to it: cart-drawer.js, main.js and any app that targets
     .cart-count all land here without needing to know about the bar. */
  function watch() {
    if (!window.MutationObserver) return;

    var observer = new MutationObserver(syncEmptyState);
    badges().forEach(function (node) {
      observer.observe(node, { childList: true, characterData: true, subtree: true });
    });
  }

  function init() {
    if (!badges().length) return;
    syncEmptyState();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // A page restored from the back/forward cache carries the cart it
  // had when it was put away, which may be several actions old.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });

  // Backstops for the two events the theme already dispatches, in case
  // an add happens on a page where the drawer section is not rendered.
  document.addEventListener('cart:added', refresh);
  document.addEventListener('cart:refresh', refresh);
})();
